import { InheritTextInputField, SubmitButton } from "./styled";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { CustomAutocompleteMultiSelect } from "../../components/CustomAutocomplete";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import {
  AiScrapeFewShotExampleDto,
  AiScrapePromptConfigDto,
  ResolvedScrapeConfigDto,
  ScrapeTimeDto,
  UpdateFlyerScraperSourceDto,
} from "@swagger/typescript-fetch-goflyer";
import { adminApiService } from "../../../utils/api";
import { useLoading } from "../../../contextApi/LoadingContext";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";
import { useMerchants } from "../../../hooks/useMerchants";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";
import { useFlyerTags } from "../../../hooks/useFlyerTags";
import { useStores } from "../../../hooks/useStores";
import { useHandleSaveFlyerScraper } from "./handleSaveFlyerScraper";
import DayTimeListManager from "../../components/DayTimeListManager";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import { CheckBoxMui } from "../../components/CheckBox";
import { v4 as uuidv4 } from "uuid";
import { disableWheelOnInput } from "../../../utils/disableWheelOnInput";
import {
  useFlippMerchants,
  FlippMerchant,
} from "../../../hooks/useFlippMerchants";
import {
  validateCanadianPostalCode,
  formatCanadianPostalCode,
} from "../../../utils/postalCodeValidator";
import { debounce } from "../../../utils/debounce";
interface ScrapeTimeDtoV2 extends ScrapeTimeDto {
  id: string;
}
const provincesList = [
  { value: { name: "ab", id: "ab" }, label: "ab" },
  { value: { name: "bc", id: "bc" }, label: "bc" },
  { value: { name: "mb", id: "mb" }, label: "mb" },
  { value: { name: "nb", id: "nb" }, label: "nb" },
  { value: { name: "nl", id: "nl" }, label: "nl" },
  { value: { name: "ns", id: "ns" }, label: "ns" },
  { value: { name: "on", id: "on" }, label: "on" },
  { value: { name: "pe", id: "pe" }, label: "pe" },
  { value: { name: "qc", id: "qc" }, label: "qc" },
  { value: { name: "sk", id: "sk" }, label: "sk" },
  { value: { name: "west", id: "west" }, label: "west" },
  { value: { name: "gta", id: "gta" }, label: "gta" },
  { value: { name: "ottawa", id: "ottawa" }, label: "ottawa" },
  { value: { name: "surrey", id: "surrey" }, label: "surrey" },
  { value: { name: "north-york", id: "north-york" }, label: "north-york" },
  { value: { name: "pickering", id: "pickering" }, label: "pickering" },
  { value: { name: "mississauga", id: "mississauga" }, label: "mississauga" },
  { value: { name: "toronto", id: "toronto" }, label: "toronto" },
  { value: { name: "milton", id: "milton" }, label: "milton" },
  { value: { name: "scarborough", id: "scarborough" }, label: "scarborough" },
  { value: { name: "montreal", id: "montreal" }, label: "montreal" },
  { value: { name: "vancouver", id: "vancouver" }, label: "vancouver" },
  { value: { name: "calgary", id: "calgary" }, label: "calgary" },
  { value: { name: "edmonton", id: "edmonton" }, label: "edmonton" },
  { value: { name: "ottawa", id: "ottawa" }, label: "ottawa" },
  { value: { name: "mississauga", id: "mississauga" }, label: "mississauga" },
  { value: { name: "winnipeg", id: "winnipeg" }, label: "winnipeg" },
  { value: { name: "brampton", id: "brampton" }, label: "brampton" },
  { value: { name: "hamilton", id: "hamilton" }, label: "hamilton" },
  { value: { name: "surrey", id: "surrey" }, label: "surrey" },
  { value: { name: "halifax", id: "halifax" }, label: "halifax" },
  { value: { name: "london", id: "london" }, label: "london" },
  { value: { name: "markham", id: "markham" }, label: "markham" },
  { value: { name: "vaughan", id: "vaughan" }, label: "vaughan" },
  { value: { name: "kitchener", id: "kitchener" }, label: "kitchener" },
  { value: { name: "windsor", id: "windsor" }, label: "windsor" },
  { value: { name: "saskatoon", id: "saskatoon" }, label: "saskatoon" },
  { value: { name: "regina", id: "regina" }, label: "regina" },
  { value: { name: "st-johns", id: "st-johns" }, label: "st-johns" },
  { value: { name: "kelowna", id: "kelowna" }, label: "kelowna" },
  { value: { name: "barrie", id: "barrie" }, label: "barrie" },
  { value: { name: "guelph", id: "guelph" }, label: "guelph" },
  {
    value: { name: "richmond-hill", id: "richmond-hill" },
    label: "richmond-hill",
  },
  { value: { name: "burnaby", id: "burnaby" }, label: "burnaby" },
  { value: { name: "longueuil", id: "longueuil" }, label: "longueuil" },
  { value: { name: "laval", id: "laval" }, label: "laval" },
  { value: { name: "gatineau", id: "gatineau" }, label: "gatineau" },
  { value: { name: "sherbrooke", id: "sherbrooke" }, label: "sherbrooke" },
  { value: { name: "saguenay", id: "saguenay" }, label: "saguenay" },
  { value: { name: "red-deer", id: "red-deer" }, label: "red-deer" },
  { value: { name: "lethbridge", id: "lethbridge" }, label: "lethbridge" },
  { value: { name: "abbotsford", id: "abbotsford" }, label: "abbotsford" },
  { value: { name: "nanaimo", id: "nanaimo" }, label: "nanaimo" },
  { value: { name: "kamloops", id: "kamloops" }, label: "kamloops" },
  { value: { name: "white-rock", id: "white-rock" }, label: "white-rock" },
  {
    value: { name: "peterborough", id: "peterborough" },
    label: "peterborough",
  },
  {
    value: { name: "medicine-hat", id: "medicine-hat" },
    label: "medicine-hat",
  },
  { value: { name: "moncton", id: "moncton" }, label: "moncton" },
  { value: { name: "saint-john", id: "saint-john" }, label: "saint-john" },
  { value: { name: "terrebonne", id: "terrebonne" }, label: "terrebonne" },
  {
    value: { name: "drummondville", id: "drummondville" },
    label: "drummondville",
  },
  {
    value: { name: "prince-george", id: "prince-george" },
    label: "prince-george",
  },
  { value: { name: "fredericton", id: "fredericton" }, label: "fredericton" },
  {
    value: { name: "saint-jerome", id: "saint-jerome" },
    label: "saint-jerome",
  },
  { value: { name: "chilliwack", id: "chilliwack" }, label: "chilliwack" },
  { value: { name: "whitehorse", id: "whitehorse" }, label: "whitehorse" },
  { value: { name: "yellowknife", id: "yellowknife" }, label: "yellowknife" },
  { value: { name: "iqaluit", id: "iqaluit" }, label: "iqaluit" },
  {
    value: { name: "charlottetown", id: "charlottetown" },
    label: "charlottetown",
  },
];
export const CreateFlyerScraper = () => {
  const { flyerScraperId } = useParams<{ flyerScraperId: string }>();
  const { showLoadingScreen } = useLoading();
  const { t } = useTranslation();

  const handleSaveFlyer = useHandleSaveFlyerScraper();
  const authHeaders = useAuthHeaders();
  const { merchantsList, isMerchantOptionLoading, handleOnMerchantSearch } =
    useMerchants();
  const { flyerTagsList } = useFlyerTags();
  const { storesList, isStoreOptionLoading, handleOnStoreSearch } = useStores();
  const {
    flippMerchants,
    isLoading: isFlippLoading,
    fetchFlippMerchants,
  } = useFlippMerchants();

  const [updateFlyerScraper, setUpdateFlyerScraper] =
    useState<UpdateFlyerScraperSourceDto>();
  const [postalCode, setPostalCode] = useState<string>("");
  const [flippMerchant, setFlippMerchant] = useState<
    FlippMerchant | undefined
  >();
  const [postalCodeError, setPostalCodeError] = useState<string>("");
  const [isValidatingPostalCode, setIsValidatingPostalCode] = useState(false);
  const [resolvedConfig, setResolvedConfig] =
    useState<ResolvedScrapeConfigDto | null>(null);
  const [isResolvedConfigOpen, setIsResolvedConfigOpen] = useState(false);

  const overrideConfig = updateFlyerScraper?.scrapePromptConfigOverride;
  const fewShotExamples = overrideConfig?.fewShotExamples ?? [];
  const isAgentMode =
    updateFlyerScraper?.scrapeMode ===
    UpdateFlyerScraperSourceDto.ScrapeModeEnum.Agent;
  const isSingleShotMode =
    updateFlyerScraper?.scrapeMode ===
    UpdateFlyerScraperSourceDto.ScrapeModeEnum.SingleShot;

  const initializeData = async () => {
    showLoadingScreen(true);
    if (flyerScraperId) {
      const flyer =
        await adminApiService.getOneBaseFlyerScraperSourceAdminControllerFlyerScraperSource(
          flyerScraperId
        );
      setUpdateFlyerScraper(flyer);

      if (flyer.flippMerchant) {
        setPostalCode(flyer.flippMerchant.postalCode || "");
        setFlippMerchant({
          id: parseInt(flyer.flippMerchant.id),
          name: flyer.flippMerchant.name,
          postalCode: flyer.flippMerchant.postalCode,
        });

        if (flyer.flippMerchant.postalCode) {
          await fetchFlippMerchants(flyer.flippMerchant.postalCode);
        }
      }
    }
    showLoadingScreen(false);
  };

  useEffect(() => {
    initializeData();
  }, []);

  const handleInputChange =
    (field: keyof UpdateFlyerScraperSourceDto) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setUpdateFlyerScraper((prev) => ({
        ...prev,
        [field]: event.target.value,
      }));
    };
  const updateScrapeTime = (value?: ScrapeTimeDtoV2[]) => {
    setUpdateFlyerScraper((prev) => ({
      ...prev,
      scrapeTimes: value,
    }));
  };

  const setOverrideField = (
    field: keyof AiScrapePromptConfigDto,
    value: unknown
  ) => {
    setUpdateFlyerScraper((prev) => ({
      ...prev,
      scrapePromptConfigOverride: {
        ...prev?.scrapePromptConfigOverride,
        [field]: value,
      } as AiScrapePromptConfigDto,
    }));
  };

  const handleOverrideNumberChange =
    (field: keyof AiScrapePromptConfigDto) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      const raw = event.target.value;
      if (raw === "") {
        setOverrideField(field, undefined);
        return;
      }
      const parsed = Number(raw);
      setOverrideField(field, Number.isNaN(parsed) ? undefined : parsed);
    };

  const addFewShotExample = () => {
    setUpdateFlyerScraper((prev) => ({
      ...prev,
      scrapePromptConfigOverride: {
        ...prev?.scrapePromptConfigOverride,
        fewShotExamples: [
          ...(prev?.scrapePromptConfigOverride?.fewShotExamples ?? []),
          { input: "", output: "" },
        ],
      },
    }));
  };

  const updateFewShotExample = (
    index: number,
    key: keyof AiScrapeFewShotExampleDto,
    value: string
  ) => {
    setUpdateFlyerScraper((prev) => {
      const list = [
        ...(prev?.scrapePromptConfigOverride?.fewShotExamples ?? []),
      ];
      list[index] = { ...list[index], [key]: value };
      return {
        ...prev,
        scrapePromptConfigOverride: {
          ...prev?.scrapePromptConfigOverride,
          fewShotExamples: list,
        },
      };
    });
  };

  const removeFewShotExample = (index: number) => {
    setUpdateFlyerScraper((prev) => {
      const list = [
        ...(prev?.scrapePromptConfigOverride?.fewShotExamples ?? []),
      ];
      list.splice(index, 1);
      return {
        ...prev,
        scrapePromptConfigOverride: {
          ...prev?.scrapePromptConfigOverride,
          fewShotExamples: list,
        },
      };
    });
  };

  const handlePreviewResolvedConfig = async () => {
    if (!updateFlyerScraper?.id) {
      return;
    }
    showLoadingScreen(true);
    try {
      const resolved =
        await adminApiService.flyerScraperSourceAdminControllerGetResolvedScrapeConfig(
          updateFlyerScraper.id,
          authHeaders
        );
      if (resolved) {
        setResolvedConfig(resolved);
        setIsResolvedConfigOpen(true);
      }
    } finally {
      showLoadingScreen(false);
    }
  };

  const debouncedFetchFlippMerchants = useCallback(
    debounce(async (postalCode: string) => {
      setIsValidatingPostalCode(true);
      try {
        await fetchFlippMerchants(postalCode);
      } finally {
        setIsValidatingPostalCode(false);
      }
    }, 500),
    [fetchFlippMerchants]
  );

  const handlePostalCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPostalCode(value);
    setPostalCodeError("");

    if (!value || value.trim() === "") {
      setFlippMerchant(undefined);
      setIsValidatingPostalCode(false);
      return;
    }

    const cleanedValue = value.replace(/\s/g, "");
    if (cleanedValue.length === 6) {
      if (validateCanadianPostalCode(value)) {
        const formatted = formatCanadianPostalCode(value);
        setPostalCode(formatted);
        debouncedFetchFlippMerchants(formatted);
      } else {
        setPostalCodeError(t(messages.Invalid_Postal_Code()) as string);
        setFlippMerchant(undefined);
        setIsValidatingPostalCode(false);
      }
    } else if (cleanedValue.length > 6) {
      setPostalCodeError(t(messages.Invalid_Postal_Code()) as string);
      setFlippMerchant(undefined);
      setIsValidatingPostalCode(false);
    }
  };

  const handlePostalCodeBlur = () => {
    if (postalCode && !validateCanadianPostalCode(postalCode)) {
      setPostalCodeError(t(messages.Invalid_Postal_Code()) as string);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        padding: { xs: 0, sm: 0, lg: "20px" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          marginTop: "30px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Paper
          sx={{
            position: "relative",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            maxWidth: "700px",
            width: "100%",
            marginTop: "40px",
          }}
        >
          <Box
            sx={{
              mb: 2,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#f58220",
              }}
            >
              {t(messages.CreateFlyerScraperSource())}
            </Typography>
          </Box>
          <Stack direction={"column"} width={"100%"} rowGap={"15px"}>
            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Typography>{t(messages.URL())} *</Typography>
              <InheritTextInputField
                placeholder={`${t(messages.URL())} *`}
                onChange={handleInputChange("url")}
                value={updateFlyerScraper?.url}
              />
            </Stack>
            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Typography></Typography>
              <InheritTextInputField
                placeholder={`${t(messages.BackURL())} *`}
                onChange={handleInputChange("backupUrl")}
                value={updateFlyerScraper?.backupUrl}
              />
            </Stack>
            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Typography>{t(messages.SecondBackURL())}</Typography>
              <InheritTextInputField
                placeholder="Second Back URL"
                onChange={handleInputChange("secondBackupUrl")}
                value={updateFlyerScraper?.secondBackupUrl}
              />
            </Stack>

            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Typography>
                  {t(messages.Postal_Code_Flipp_Merchant())}
                </Typography>
                <Tooltip
                  title={t(messages.Flipp_PostalCode_Tooltip()) as string}
                  arrow
                  placement="top"
                >
                  <InfoOutlinedIcon
                    sx={{
                      color: "#666",
                      cursor: "help",
                      fontSize: "18px",
                    }}
                  />
                </Tooltip>
              </Stack>
              <InheritTextInputField
                placeholder={t(messages.Postal_Code_Example()) as string}
                onChange={handlePostalCodeChange}
                onBlur={handlePostalCodeBlur}
                value={postalCode}
                disabled={isValidatingPostalCode}
              />
              {postalCodeError && (
                <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
                  {postalCodeError}
                </Typography>
              )}
              {isValidatingPostalCode && (
                <Typography
                  sx={{ color: "#f58220", fontSize: "12px", mt: 0.5 }}
                >
                  {t(messages.Loading())}
                </Typography>
              )}
            </Stack>

            {flippMerchants.length > 0 &&
              postalCode &&
              !postalCodeError &&
              validateCanadianPostalCode(postalCode) && (
                <CustomAutocompleteMultiSelect
                  title={t(messages.Flipp_Merchant()) as string}
                  dataTestId="flipp-merchant"
                  isLoading={isFlippLoading || isValidatingPostalCode}
                  selectedValues={
                    flippMerchant
                      ? [
                          {
                            value: flippMerchant,
                            label: flippMerchant.name,
                          },
                        ]
                      : []
                  }
                  handleOnChange={(merchants) => {
                    setFlippMerchant(merchants?.[0]);
                  }}
                  optionsList={flippMerchants.map((merchant) => ({
                    value: merchant,
                    label: merchant.name,
                  }))}
                  multiSelect={false}
                  WrapperCss="margin-left:0px; margin-top:10px; width:100%; max-width: 664px;"
                  inputCss="width:100%; max-width: 664px;"
                  inputTextCss="width:100%; max-width: 664px;"
                />
              )}

            <CustomAutocompleteMultiSelect
              title={`${t(messages.Merchant())} *`}
              dataTestId="merchant"
              isLoading={isMerchantOptionLoading}
              selectedValues={
                updateFlyerScraper?.merchant
                  ? [
                      {
                        value: updateFlyerScraper.merchant,
                        label: updateFlyerScraper.merchant.name,
                      },
                    ]
                  : []
              }
              handleOnChange={(merchants) => {
                setUpdateFlyerScraper((prev) => ({
                  ...prev,
                  merchant: merchants?.[0],
                  stores: undefined,
                }));
              }}
              optionsList={merchantsList?.map((merchant) => ({
                value: merchant,
                label: merchant.name,
              }))}
              handleOnSearch={handleOnMerchantSearch}
              multiSelect={false}
              WrapperCss="margin-left:0px; margin-top:10px; width:100%; max-width: 664px;"
              inputCss="width:100%; max-width: 664px;"
              inputTextCss="width:100%; max-width: 664px;"
            />

            {updateFlyerScraper?.merchant ? null : (
              <CustomAutocompleteMultiSelect
                title={`${t(messages.Store())} *`}
                dataTestId="store"
                optionsList={storesList?.map((store) => ({
                  value: store,
                  label: makeStoreDisplayName(store),
                }))}
                isLoading={isStoreOptionLoading}
                selectedValues={updateFlyerScraper?.stores?.map((store) => ({
                  value: store,
                  label: makeStoreDisplayName(store),
                }))}
                multiSelect
                handleOnChange={(stores) => {
                  setUpdateFlyerScraper((prev) => ({
                    ...prev,
                    stores: stores,
                  }));
                }}
                handleOnSearch={handleOnStoreSearch}
                WrapperCss="margin-left:0px; margin-top:10px; width:100%; max-width: 664px;"
                inputCss="width:100%; max-width: 664px;"
              />
            )}

            <Stack direction={"row"} columnGap={"10px"}>
              <CustomAutocompleteMultiSelect
                dataTestId="flyer-tag"
                title={`${t(messages.Flyer_Tag())} *`}
                optionsList={flyerTagsList?.map((tag) => ({
                  value: tag,
                  label: tag.name,
                }))}
                selectedValues={updateFlyerScraper?.flyerTag?.map((tag) => ({
                  value: tag,
                  label: tag.name,
                }))}
                multiSelect
                handleOnChange={(value) => {
                  setUpdateFlyerScraper((prev) => ({
                    ...prev,
                    flyerTag: value,
                  }));
                }}
                WrapperCss="margin-left:0px; margin-top:10px; width:100%; max-width: 664px;"
                inputCss="width:100%; max-width: 664px;"
              />

              <CustomAutocompleteMultiSelect
                dataTestId="provinces"
                title={`${t(messages.Provinces())}`}
                optionsList={provincesList}
                selectedValues={updateFlyerScraper?.provinces?.map((prov) => ({
                  value: { name: prov, id: prov },
                  label: prov,
                }))}
                multiSelect
                handleOnChange={(value) => {
                  setUpdateFlyerScraper((prev) => ({
                    ...prev,
                    provinces: value?.map((val) => val.name) || [],
                  }));
                }}
                WrapperCss="margin-left:0px; margin-top:10px; width:100%; max-width: 664px;"
                inputCss="width:100%; max-width: 664px;"
              />
            </Stack>
            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Typography>{t(messages.Interval())}</Typography>
              <InheritTextInputField
                placeholder={t(messages.Interval()) as string}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  setUpdateFlyerScraper((prev) => ({
                    ...prev,
                    interval: parseInt(event.target.value),
                  }));
                }}
                value={updateFlyerScraper?.interval}
                type="number"
                onWheel={disableWheelOnInput}
              />
            </Stack>
            <Stack direction={"column"} width={"100%"} rowGap={"2px"}>
              <Typography>{t(messages.ScrapeTime())}</Typography>
              <DayTimeListManager<ScrapeTimeDtoV2>
                dayTimeValues={updateFlyerScraper?.scrapeTimes?.map((val) => ({
                  ...val,
                  id: uuidv4(),
                }))}
                onUpdateDayTime={updateScrapeTime}
                sx={{ textAlign: "center", mt: 2 }}
              />
            </Stack>

            <Divider sx={{ width: "100%" }} />

            <Stack direction={"column"} width={"100%"} rowGap={"10px"}>
              <CheckBoxMui
                dataTestId="ai-scrape-enabled"
                title={t(messages.AI_Scrape_Enabled()) as string}
                tooltip={t(messages.AI_Scrape_Enabled_Tooltip()) as string}
                value={!!updateFlyerScraper?.aiScrapeEnabled}
                onChange={(_event, checked) => {
                  setUpdateFlyerScraper((prev) => ({
                    ...prev,
                    aiScrapeEnabled: checked,
                  }));
                }}
              />

              <Stack
                direction={"column"}
                rowGap={"2px"}
                sx={{ maxWidth: "300px" }}
              >
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <Typography>{t(messages.Scrape_Mode())}</Typography>
                  <Tooltip
                    title={t(messages.Scrape_Mode_Tooltip()) as string}
                    arrow
                    placement="top"
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color: "#666",
                        cursor: "help",
                        fontSize: "18px",
                      }}
                    />
                  </Tooltip>
                </Stack>
                <Select
                  size="small"
                  displayEmpty
                  data-testid="scrape-mode"
                  value={updateFlyerScraper?.scrapeMode ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUpdateFlyerScraper((prev) => ({
                      ...prev,
                      scrapeMode: value
                        ? (value as UpdateFlyerScraperSourceDto.ScrapeModeEnum)
                        : undefined,
                    }));
                  }}
                >
                  <MenuItem value="">
                    {t(messages.Fall_Back_To_Global())}
                  </MenuItem>
                  <MenuItem value="agent">{t(messages.Agent())}</MenuItem>
                  <MenuItem value="single-shot">
                    {t(messages.Single_Shot())}
                  </MenuItem>
                </Select>
              </Stack>

              <Accordion
                disableGutters
                sx={{
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {t(messages.Prompt_Config_Override())}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack direction={"column"} width={"100%"} rowGap={"15px"}>
                    <Typography sx={{ fontSize: "12px", color: "#666" }}>
                      {t(messages.Prompt_Config_Override_Hint())}
                    </Typography>

                    {!isAgentMode && (
                      <Stack direction={"column"} rowGap={"2px"}>
                        <Typography>
                          {t(messages.System_Prompt())}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "11px",
                              color: "#999",
                              ml: 1,
                              fontStyle: "italic",
                            }}
                          >
                            ({t(messages.Mode_Single_Shot_Only())})
                          </Typography>
                        </Typography>
                        <TextField
                          multiline
                          minRows={3}
                          fullWidth
                          size="small"
                          value={overrideConfig?.systemPrompt ?? ""}
                          onChange={(e) =>
                            setOverrideField("systemPrompt", e.target.value)
                          }
                          inputProps={{
                            "data-testid": "override-system-prompt",
                          }}
                        />
                      </Stack>
                    )}

                    {!isAgentMode && (
                      <Stack direction={"column"} rowGap={"2px"}>
                        <Typography>
                          {t(messages.Developer_Prompt())}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "11px",
                              color: "#999",
                              ml: 1,
                              fontStyle: "italic",
                            }}
                          >
                            ({t(messages.Mode_Single_Shot_Only())})
                          </Typography>
                        </Typography>
                        <TextField
                          multiline
                          minRows={3}
                          fullWidth
                          size="small"
                          value={overrideConfig?.developerPrompt ?? ""}
                          onChange={(e) =>
                            setOverrideField("developerPrompt", e.target.value)
                          }
                        />
                      </Stack>
                    )}

                    {!isAgentMode && (
                      <Stack direction={"column"} rowGap={"2px"}>
                        <Typography>
                          {t(messages.User_Prompt_Template())}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "11px",
                              color: "#999",
                              ml: 1,
                              fontStyle: "italic",
                            }}
                          >
                            ({t(messages.Mode_Single_Shot_Only())})
                          </Typography>
                        </Typography>
                        <TextField
                          multiline
                          minRows={3}
                          fullWidth
                          size="small"
                          helperText={t(messages.User_Prompt_Template_Hint())}
                          value={overrideConfig?.userPromptTemplate ?? ""}
                          onChange={(e) =>
                            setOverrideField(
                              "userPromptTemplate",
                              e.target.value
                            )
                          }
                        />
                      </Stack>
                    )}

                    {!isSingleShotMode && (
                      <Stack direction={"column"} rowGap={"2px"}>
                        <Typography>
                          {t(messages.Agent_Hints())}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: "11px",
                              color: "#999",
                              ml: 1,
                              fontStyle: "italic",
                            }}
                          >
                            ({t(messages.Mode_Agent_Only())})
                          </Typography>
                        </Typography>
                        <TextField
                          multiline
                          minRows={3}
                          fullWidth
                          size="small"
                          helperText={t(messages.Agent_Hints_Hint())}
                          value={overrideConfig?.agentHints ?? ""}
                          onChange={(e) =>
                            setOverrideField("agentHints", e.target.value)
                          }
                          inputProps={{
                            "data-testid": "override-agent-hints",
                          }}
                        />
                      </Stack>
                    )}

                    <Stack direction={"column"} rowGap={"2px"}>
                      <Typography>{t(messages.Output_Schema())}</Typography>
                      <TextField
                        multiline
                        minRows={3}
                        fullWidth
                        size="small"
                        value={overrideConfig?.outputSchema ?? ""}
                        onChange={(e) =>
                          setOverrideField("outputSchema", e.target.value)
                        }
                        inputProps={{ "data-testid": "override-output-schema" }}
                      />
                    </Stack>

                    <Stack direction={"column"} rowGap={"2px"}>
                      <Typography>{t(messages.Model())}</Typography>
                      <InheritTextInputField
                        placeholder={t(messages.Model()) as string}
                        value={overrideConfig?.model ?? ""}
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                          setOverrideField("model", event.target.value)
                        }
                      />
                    </Stack>

                    <Stack direction={"row"} columnGap={"10px"}>
                      <Stack
                        direction={"column"}
                        rowGap={"2px"}
                        width={"100%"}
                      >
                        <Typography>{t(messages.Temperature())}</Typography>
                        <InheritTextInputField
                          placeholder={t(messages.Temperature()) as string}
                          type="number"
                          value={overrideConfig?.temperature ?? ""}
                          onChange={handleOverrideNumberChange("temperature")}
                          onWheel={disableWheelOnInput}
                        />
                      </Stack>
                      <Stack
                        direction={"column"}
                        rowGap={"2px"}
                        width={"100%"}
                      >
                        <Typography>{t(messages.Top_P())}</Typography>
                        <InheritTextInputField
                          placeholder={t(messages.Top_P()) as string}
                          type="number"
                          value={overrideConfig?.topP ?? ""}
                          onChange={handleOverrideNumberChange("topP")}
                          onWheel={disableWheelOnInput}
                        />
                      </Stack>
                    </Stack>

                    <Stack direction={"row"} columnGap={"10px"}>
                      <Stack
                        direction={"column"}
                        rowGap={"2px"}
                        width={"100%"}
                      >
                        <Typography>
                          {t(messages.Max_Output_Tokens())}
                        </Typography>
                        <InheritTextInputField
                          placeholder={
                            t(messages.Max_Output_Tokens()) as string
                          }
                          type="number"
                          value={overrideConfig?.maxOutputTokens ?? ""}
                          onChange={handleOverrideNumberChange(
                            "maxOutputTokens"
                          )}
                          onWheel={disableWheelOnInput}
                        />
                      </Stack>
                      <Stack
                        direction={"column"}
                        rowGap={"2px"}
                        width={"100%"}
                      >
                        <Typography>{t(messages.Seed())}</Typography>
                        <InheritTextInputField
                          placeholder={t(messages.Seed()) as string}
                          type="number"
                          value={overrideConfig?.seed ?? ""}
                          onChange={handleOverrideNumberChange("seed")}
                          onWheel={disableWheelOnInput}
                        />
                      </Stack>
                    </Stack>

                    <Stack direction={"row"} columnGap={"10px"}>
                      <Stack
                        direction={"column"}
                        rowGap={"2px"}
                        width={"100%"}
                      >
                        <Typography>
                          {t(messages.Reasoning_Effort())}
                        </Typography>
                        <Select
                          size="small"
                          displayEmpty
                          value={overrideConfig?.reasoningEffort ?? ""}
                          onChange={(e) =>
                            setOverrideField(
                              "reasoningEffort",
                              e.target.value || undefined
                            )
                          }
                        >
                          <MenuItem value="">
                            {t(messages.Fall_Back_To_Global())}
                          </MenuItem>
                          {Object.values(
                            AiScrapePromptConfigDto.ReasoningEffortEnum
                          ).map((value) => (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          ))}
                        </Select>
                      </Stack>
                      {!isAgentMode && (
                        <Stack
                          direction={"column"}
                          rowGap={"2px"}
                          width={"100%"}
                        >
                          <Typography>
                            {t(messages.Response_Format())}
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "11px",
                                color: "#999",
                                ml: 1,
                                fontStyle: "italic",
                              }}
                            >
                              ({t(messages.Mode_Single_Shot_Only())})
                            </Typography>
                          </Typography>
                          <Select
                            size="small"
                            displayEmpty
                            value={overrideConfig?.responseFormat ?? ""}
                            onChange={(e) =>
                              setOverrideField(
                                "responseFormat",
                                e.target.value || undefined
                              )
                            }
                          >
                            <MenuItem value="">
                              {t(messages.Fall_Back_To_Global())}
                            </MenuItem>
                            {Object.values(
                              AiScrapePromptConfigDto.ResponseFormatEnum
                            ).map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </Stack>
                      )}
                    </Stack>

                    {!isAgentMode && (
                      <Stack direction={"column"} rowGap={"10px"}>
                        <Stack
                          direction={"row"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                        >
                          <Typography sx={{ fontWeight: "bold" }}>
                            {t(messages.Few_Shot_Examples())}
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "11px",
                                color: "#999",
                                ml: 1,
                                fontStyle: "italic",
                                fontWeight: "normal",
                              }}
                            >
                              ({t(messages.Mode_Single_Shot_Only())})
                            </Typography>
                          </Typography>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={addFewShotExample}
                            sx={{
                              color: "#f58220",
                              borderColor: "#f58220",
                            }}
                          >
                            {t(messages.Add_Example())}
                          </Button>
                        </Stack>
                        {fewShotExamples.map((example, index) => (
                        <Stack
                          key={index}
                          direction={"column"}
                          rowGap={"6px"}
                          sx={{
                            border: "1px solid #eee",
                            borderRadius: "5px",
                            padding: "10px",
                          }}
                        >
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Typography sx={{ fontSize: "13px" }}>
                              #{index + 1}
                            </Typography>
                            <IconButton
                              size="small"
                              aria-label={t(messages.Remove()) as string}
                              onClick={() => removeFewShotExample(index)}
                            >
                              <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                          <TextField
                            multiline
                            minRows={2}
                            fullWidth
                            size="small"
                            label={t(messages.Example_Input())}
                            value={example.input ?? ""}
                            onChange={(e) =>
                              updateFewShotExample(
                                index,
                                "input",
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            multiline
                            minRows={2}
                            fullWidth
                            size="small"
                            label={t(messages.Example_Output())}
                            value={example.output ?? ""}
                            onChange={(e) =>
                              updateFewShotExample(
                                index,
                                "output",
                                e.target.value
                              )
                            }
                          />
                        </Stack>
                        ))}
                      </Stack>
                    )}
                  </Stack>
                </AccordionDetails>
              </Accordion>

              {updateFlyerScraper?.id && (
                <Stack
                  direction={"row"}
                  width={"100%"}
                  justifyContent={"flex-start"}
                >
                  <Button
                    variant="outlined"
                    onClick={handlePreviewResolvedConfig}
                    data-testid="preview-resolved-config"
                    sx={{ color: "#f58220", borderColor: "#f58220" }}
                  >
                    {t(messages.Preview_Resolved_Config())}
                  </Button>
                </Stack>
              )}
            </Stack>

            <Stack direction={"row"} width={"100%"} justifyContent={"flex-end"}>
              <SubmitButton
                onClick={async () => {
                  if (updateFlyerScraper) {
                    await handleSaveFlyer({
                      ...updateFlyerScraper,
                      flippMerchant: flippMerchant
                        ? {
                            ...flippMerchant,
                            id: flippMerchant.id.toString(),
                          }
                        : undefined,
                    });
                  }
                }}
                data-testid="submit-button"
              >
                {updateFlyerScraper?.id
                  ? t(messages.Update())
                  : t(messages.Save())}
              </SubmitButton>
            </Stack>
          </Stack>
        </Paper>
      </Box>

      <Dialog
        open={isResolvedConfigOpen}
        onClose={() => setIsResolvedConfigOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {t(messages.Resolved_Scrape_Config())}
          <IconButton
            aria-label="close"
            onClick={() => setIsResolvedConfigOpen(false)}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {resolvedConfig && (
            <Stack direction={"column"} rowGap={"10px"}>
              <Stack direction={"row"} columnGap={"8px"} flexWrap={"wrap"}>
                <Chip
                  label={`${t(messages.Use_Ai_Scraper())}: ${
                    resolvedConfig.useAiScraper
                      ? t(messages.Enabled())
                      : t(messages.Disabled())
                  }`}
                  color={resolvedConfig.useAiScraper ? "success" : "default"}
                  size="small"
                />
                <Chip
                  label={`${t(messages.Global_Enabled())}: ${
                    resolvedConfig.globalEnabled
                      ? t(messages.Enabled())
                      : t(messages.Disabled())
                  }`}
                  size="small"
                />
                <Chip
                  label={`${t(messages.Source_Ai_Scrape_Enabled())}: ${
                    resolvedConfig.sourceAiScrapeEnabled
                      ? t(messages.Enabled())
                      : t(messages.Disabled())
                  }`}
                  size="small"
                />
                <Chip
                  label={`${t(messages.Fetch_Strategy())}: ${
                    resolvedConfig.fetchStrategy
                  }`}
                  size="small"
                />
                <Chip
                  label={`${t(messages.Scrape_Mode())}: ${
                    resolvedConfig.scrapeMode ?? "—"
                  }`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              </Stack>

              <Stack direction={"column"} rowGap={"4px"}>
                <Typography sx={{ fontWeight: "bold" }}>
                  {t(messages.Overridden_Fields())}
                </Typography>
                {resolvedConfig.overriddenFields?.length ? (
                  <Stack
                    direction={"row"}
                    columnGap={"6px"}
                    rowGap={"6px"}
                    flexWrap={"wrap"}
                  >
                    {resolvedConfig.overriddenFields.map((field) => (
                      <Chip key={field} label={field} size="small" />
                    ))}
                  </Stack>
                ) : (
                  <Typography sx={{ fontSize: "13px", color: "#666" }}>
                    —
                  </Typography>
                )}
              </Stack>

              <Divider />

              <Typography
                component="pre"
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: "5px",
                  padding: "12px",
                  fontSize: "12px",
                  fontFamily: "monospace",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  margin: 0,
                }}
              >
                {JSON.stringify(resolvedConfig.promptConfig, null, 2)}
              </Typography>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};
